import { render } from "./portfolio-home.vue?vue&type=template&id=6f4e01be&scoped=true&ts=true"
import script from "./portfolio-home.vue?vue&type=script&lang=ts"
export * from "./portfolio-home.vue?vue&type=script&lang=ts"

import "./portfolio-home.vue?vue&type=style&index=0&id=6f4e01be&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4e01be"]])

export default __exports__